"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConcatFormat = ConcatFormat;

function ConcatFormat(params) {
  var row = params.data;
  var result = '';
  params.colDef.concattedFields.map(function (item) {
    result = result + row[item];
  });
  return result;
}